<template>
  <div class="main-content">
    <!-- Content Menu -->
    <div role="tablist" class="tablist" :class="{ collapsed: !showLogo }">
      <b-card no-body class="mb-1" v-for="(item, index) in menu" :key="index">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle="'menu_' + item.id"
            variant="default"
            class="font-size-14 color-contipark"
          >
            {{ item.label }}
          </b-button>
        </b-card-header>
        <b-collapse
          :id="'menu_' + item.id"
          visible
          accordion="menu"
          role="tabpanel"
        >
          <b-card-body>
            <div
              class="menu"
              :style="{ height: contentMenuHeight }"
              :class="{ collapsed: !showLogo }"
            >
              <content-menu
                ref="menu"
                :menuFirstItemId="'menu_' + item.id"
                :menuTitle="item.label"
                :menuData="menuData"
                :menu="item.children"
                @fetchApplicationDevices="fetchApplicationDevices"
                @unselectItem="unselectApplicationAndDevices"
              ></content-menu>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <!-- content Logo -->
    <div class="content mobilehide" v-if="showLogo">
      <div class="settings-sbhlogo__overlay">
        <div class="sbh-content-logo"></div>
      </div>
    </div>
    <!-- Application Child -->
    <router-view v-if="showDevices"></router-view>
  </div>
</template>

<script>
import ContentMenu from "./contentMenu";
import UserService from "../services/user-service";
import ParsingService from "../services/parsing-service";
import ApiService from "../services/api-service";
import moment from "moment";
import get from "lodash/get";

export default {
  name: "Main",
  components: {
    ContentMenu
  },
  data() {
    return {
      content: "iot",
      menuData: { custom01: [] },
      menu: [],

      user: {},

      noDevicesFound: false,
      contentMenuHeight: "92vh",

      websocket: null,

      defaultMenu: { id: "01", label: "menu", children: [] },

      showLogo: true,
      showDevices: false,
      account: null
    };
  },
  mounted() {
    //set User
    this.user = UserService.getUser();
    setTimeout(() => {
      this.$loader.endLoading("Main");
      this.$Progress.finish();
    }, 500);
  },
  beforeCreate() {
    this.$loader.startLoading("Main");
    this.$Progress.start();
  },
  created() {
    this.fetchApplications();
    if (!this.$store.state.account) {
      this.fetchAccount();
    } else {
      this.createMenu();
    }
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.$bus.on("fetchApplicationDevices", this.fetchApplicationDevices);
    this.$bus.on(
      "unselectApplicationAndDevices",
      this.unselectApplicationAndDevices
    );

    this.$bus.on("change-map-style", this.changeMapStyle);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    navigation(target) {
      this.content = target;
      this.$store.state.application = {};
    },
    loadMapStyle() {
      var defaultTheme =
        localStorage.getItem("niotaMapsTheme") == null
          ? "mapbox://styles/attx/cjhao9esl0asu2so9j4gb1n1b"
          : localStorage.getItem("niotaMapsTheme");
      this.changeMapStyle(defaultTheme);
    },
    changeMapStyle(style) {
      localStorage.setItem("sbhMapsTheme", style);
      this.mapStyle = style;
    },
    connectWebsocket() {
      let vm = this;
      let wsUri = `${process.env.VUE_APP_NIOTA_WS}/accounts/${
        this.account.id
      }?auth=${this.account.data.realTimeApiKey}`;

      this.websocket = new WebSocket(wsUri);
      this.$store.state.websocket = this.websocket;

      this.websocket.onclose = () => {
        if (!this.$store.state.websocketClosed) {
          vm.connectWebsocket();
        }
      };
      this.websocket.onmessage = evt => {
        vm.onWebsocketMessage(evt);
      };
    },
    onWebsocketMessage(evt) {
      let packet = JSON.parse(evt.data);
      if (Array.isArray(this.$store.state.devices)) {
        this.$store.state.devices.forEach(device => {
          if (device.eui === packet.eui) {
            try {
              device.packets[0].source_data.parsed = packet.parsed;
              device.packets[0].parsed = packet.parsed;
            } catch (e) {
              this.$notify({
                type: "error",
                message: e,
                position: "bottom-left"
              });
            }
            device = ParsingService.parsePacket(device);
            device.hasAlert = ParsingService.detectAlert(device);
            if (device.hasAlert) {
              this.$notify({
                type: "warning",
                message: `Neues Ereignis: ${device.title} - ${
                  device.parsedData.output
                } in ${device.description}`,
                position: "bottom-left",
                onClick: () => {
                  this.$bus.emit("tableRowClicked", device);
                }
              });
            }
          }
        });
      }
      if (this.$store.state.devices.length) {
        this.fetchAlertAndTilesTable();
      }
    },
    fetchApplicationDevices(applicationId) {
      // Load application from memory
      this.loadApplication(applicationId);
      // Select devices from IoT Hub
      ApiService.getApplicationDevices(this, applicationId)
        .then(devices => {
          if (Array.isArray(devices)) {
            devices.forEach(device => {
              if (device.packets[0]) {
                device.lastPacketTimestamp = moment(
                  device.packets[0].source_time
                ).format("DD.MM.YYYY - HH:mm");
              }
              device = ParsingService.parsePacket(device);
              device.hasAlert = ParsingService.detectAlert(device);
            });
            if (!devices || !devices.length) {
              this.noDevicesFound = true;
              return;
            }
            this.$store.state.devices = devices;
            this.$store.state.devicesForMapMarkers = devices;
            this.fetchAlertAndTilesTable();
          }
        })
        .catch(response => {
          this.loading = false;
          this.$notify({
            type: "error",
            message: `Ein Fehler ist aufgetreten: ${response}`,
            position: "bottom-left"
          });
        });
    },
    unselectApplicationAndDevices() {
      this.toggleLogoShow();
    },
    loadApplication(applicationId) {
      let application = this.$store.state.applications.find(
        a => a.id === Number(applicationId)
      );
      this.$store.state.application = application;
    },
    fetchAlertAndTilesTable() {
      // Build Alert Table
      this.fetchAlertTable();
      // Build Tile table
      var result = ParsingService.buildTileObject(
        this,
        this.$store.state.devices
      );
      this.$store.state.tilesTable = result.tilesTable;
      this.$store.state.filterData = result.filter;
    },
    fetchAlertTable() {
      this.$store.state.alertTable = [];
      if (Array.isArray(this.$store.state.devices)) {
        this.$store.state.devices.forEach(device => {
          return device.hasAlert
            ? this.$store.state.alertTable.push(device)
            : null;
        });
      }
      this.toggleLogoHide();
    },
    fetchApplications() {
      var applications = this.$store.state.applications;
      if (!applications.length) {
        ApiService.getApplications(this)
          .then(applications => {
            if (!applications || !applications.length) {
              return;
            }
            applications.forEach(application => {
              application._hidden = false;
              application._selected = false;
            });
            this.$store.state.applications = applications;
          })
          .catch(response => {
            this.loading = false;
            this.$notify({
              type: "error",
              message: `Ein Fehler ist aufgetreten: ${response}`,
              position: "bottom-left"
            });
          });
      }
    },
    displayDeviceFromSearch(row) {
      let device = row;
      ApiService.getDevice(this, device.id)
        .then(device => {
          ApiService.getDevicePackets(this, device.id, 50).then(packets => {
            device.packets = packets;
            device = ParsingService.parsePacket(device);
            this.$bus.emit("tableRowClicked", device);
            //this.tableRowClicked(device);
          });
        })
        .catch(response => {
          this.loading = false;
          this.$notify({
            type: "error",
            message: `Ein Fehler ist aufgetreten: ${response}`,
            position: "bottom-left"
          });
        });
    },
    handleResize() {
      let width = window.innerWidth;
      let height = window.innerHeight;
      if (width <= 768) {
        this.contentMenuHeight = height - 148 + "px";
      } else {
        this.contentMenuHeight = height - 88 + "px";
      }
    },
    toggleLogoHide() {
      this.showLogo = false;
      this.showDevices = true;
      this.$bus.emit("appl-title", this.$store.state.application.title);
    },
    toggleLogoShow() {
      this.showLogo = true;
      this.showDevices = false;
      this.$bus.emit("appl-title-remove");
    },
    createMenu() {
      let user = UserService.getUser();
      let account = this.$store.state.account;
      let userMenu = get(user, "properties.appMenu");
      let accountMenu = get(account, "properties.appMenu");

      if (userMenu && userMenu.length > 0) {
        this.menu = userMenu;
        if (
          this.menu.length == 1 &&
          (accountMenu && accountMenu.lenght === 1)
        ) {
          let menu = accountMenu;
          this.menu.push(menu[0]);
        }
      } else if (accountMenu && accountMenu.length) {
        this.menu = accountMenu;
      }
      if (this.menu.length === 1) {
        this.contentMenuHeight = "100vh";
      }
      if (!userMenu && !accountMenu) {
        this.menu.push(this.defaultMenu);
        this.contentMenuHeight = "100vh";
        return;
      }
    },
    fetchAccount() {
      this.loading = true;
      ApiService.getAccount(this, this.$store.state.accountId)
        .then(result => {
          if (result.error) {
            this.loading = false;
            this.$notify({
              type: "error",
              message: `Fehler beim Lesen des Menus: ${result.error.msg}`,
              position: "bottom-left"
            });
            return;
          }
          this.account = result;
          this.$store.commit("setAccount", this.account);
          //websocket
          let websocket = this.$store.state.websocket;
          if (websocket == null) {
            this.connectWebsocket();
          }
          this.createMenu();
        })
        .catch(error => {
          this.loading = false;
          this.$notify({
            type: "error",
            message: `Ein Fehler ist aufgetreten: ${error}`,
            position: "bottom-left"
          });
        });
    }
  }
};
</script>

<style scoped>
li:hover {
  color: #003871 !important;
}
</style>
